import { BackrsUser } from '@backrs_ui/common-ui';

import { personInitial, personName } from '@backrs_ui/grow-ui/src/utils/personName';

import { Box, Typography, Avatar, SxProps, Theme } from '@mui/material';

interface UserItemProps {
  user: BackrsUser;
}

export const AssigneeEmulationPaletteUserItem = ({ user }: UserItemProps) => {
  const initials = [user.first_name, user.last_name]
    .map((part) => personInitial({ first_name: part, last_name: null }))
    .join('');
  const fullName = personName(user);
  const username = `${user.email}`;

  return (
    <Box sx={containerSx}>
      <Avatar src={user.profile_image} alt={fullName} sx={avatarSx}>
        {initials}
      </Avatar>
      <Box sx={userInfoSx}>
        <Typography variant="text-sm-semibold" sx={nameSx}>
          {fullName}
        </Typography>
        <Typography variant="text-xs-regular" sx={usernameSx}>
          {username}
        </Typography>
      </Box>
    </Box>
  );
};

// Styling
const containerSx: SxProps<Theme> = ({ backrs }) => ({
  display: 'flex',
  alignItems: 'center',
  gap: backrs.spacing['spacing-md'],
  width: '100%',
  backgroundColor: 'transparent',
  borderRadius: backrs.radius['radius-md'],
  padding: backrs.spacing['spacing-sm'],
  margin: `-${backrs.spacing['spacing-sm']}`,
});

const avatarSx: SxProps<Theme> = ({ backrs }) => ({
  width: 40,
  height: 40,
  fontWeight: 600,
  backgroundColor: backrs.colors['Colors/Background/bg-tertiary'],
  color: backrs.colors['Colors/Foreground/fg-primary'],
});

const userInfoSx: SxProps<Theme> = {
  display: 'flex',
  flexDirection: 'column',
  flex: 1,
  minWidth: 0, // Allow text truncation
};

const nameSx: SxProps<Theme> = ({ backrs }) => ({
  color: backrs.colors['Colors/Foreground/fg-primary'],
  whiteSpace: 'nowrap',
  overflow: 'hidden',
  textOverflow: 'ellipsis',
});

const usernameSx: SxProps<Theme> = ({ backrs }) => ({
  color: backrs.colors['Colors/Foreground/fg-secondary'],
  whiteSpace: 'nowrap',
  overflow: 'hidden',
  textOverflow: 'ellipsis',
});
